import { Field, useFormikContext } from "formik";
import React, { FC } from "react";
import { REPORTS_FILTER_DATE_TIME_DATE_RANGE, REPORTS_FILTER_DATE_TIME_SPECIFIC_DATE } from "../../../constants/element-type";
import { HOURS_WORKED, REPORTS_ABSENTEEISM } from "../../../constants/menu-types";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useLocale } from "../../../contexts/localeContext";
import { useTable } from "../../../contexts/table/TableContext";
import { requiredValidation, validateRequiredEndDate, validateRequiredEndDateWithinOneMonth, validateRequiredEndDateWithinOneWeek } from "../../../utilities/Validation";
import DateField from "../../date-field/date-field";
import WeekPickerField from "../../date-field/week-picker-field";
import Label from "../../label/label";
import { WizardStepLayout } from '../../wizard/wizard-summary-layout';

interface DetailsStepProps {
    onNext: (event: any) => void;
    onBack: (event: any) => void;
    onWeekDatesChange?: (start: Date, end: Date) => void;
}

export const Detail: FC<DetailsStepProps> = ({ onBack, onNext, onWeekDatesChange }) => {
    const { translate } = useLocale();
    const { values, isValid, errors } = useFormikContext<any>();
    const tableContext = useTable();
    const endDateValidator = tableContext.menuId === HOURS_WORKED
        ? (value) => validateRequiredEndDateWithinOneMonth(value, values.startDate, translate)
        : tableContext.menuId === REPORTS_ABSENTEEISM
        ? (value) => validateRequiredEndDateWithinOneWeek(value, values.startDate, translate)
        : (value) => validateRequiredEndDate(value, values.startDate, translate);

    return <WizardStepLayout onBack={onBack} onNext={(e) => isValid ? onNext(e) : null} nextDisabled={!isValid}>
        <div className="flex flex-col py-4 px-8">
            {
                values.categoryElementSysname === REPORTS_FILTER_DATE_TIME_SPECIFIC_DATE || values.categoryElementSysname === REPORTS_FILTER_DATE_TIME_DATE_RANGE ?
                    <>
                        <span className={`mb-3 text-portal-blue-primary text-xl font-semibold`}>
                            {translate.byKey(TranslationKeys.selectDateFilter)}
                        </span>
                        {tableContext.menuId === REPORTS_ABSENTEEISM && values.categoryElementSysname === REPORTS_FILTER_DATE_TIME_DATE_RANGE ? (
                            <div className="mb-2">
                                <div className="flex flex-row justify-between">
                                    <Label htmlFor="startDate" className="text-xs text-gray-600 mt-1" required>
                                        {translate.byKey(TranslationKeys.pleaseSelectAWeek)}:
                                    </Label>
                                </div>
                                <WeekPickerField onWeekDatesChange={onWeekDatesChange} />
                            </div>
                        ) : (
                            <div className="mb-2">
                                <div className="flex flex-row justify-between" id='startDateLabelId' >
                                    <Label
                                        htmlFor="startDate"
                                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.startDate)}:</Label>
                                    {<span className='text-red-600 text-xs'>{errors.startDate}</span>}
                                </div>
                                <div className="flex flex-row justify-between" id='startDatePickerId' >
                                    <Field
                                        valueName="startDate"
                                        type="text"
                                        name="startDate"
                                        component={DateField}
                                        validate={(value) => requiredValidation(value, translate)} />
                                </div>
                            </div>
                        )}
                    </> : null}
            {
                values.categoryElementSysname === REPORTS_FILTER_DATE_TIME_DATE_RANGE && tableContext.menuId !== REPORTS_ABSENTEEISM ?
                    <div className="mb-2">
                        <div className="flex flex-row justify-between" id='endDateLabelId' >
                            <Label
                                htmlFor="endDate"
                                className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.endDate)}:</Label>
                            {<span className='text-red-600 text-xs'>{errors.endDate}</span>}
                        </div>
                        <div className="flex flex-row justify-between" id='endDatePickerId' >
                            <Field valueName="endDate"
                                type="text"
                                name="endDate"
                                component={DateField}
                                validate={endDateValidator} />
                        </div>
                    </div> : null
            }
        </div>
    </WizardStepLayout>
}


